<div id="term_condition__Modal" data-backdrop="static" data-keyboard="false" class="feedback__modal progress__modal"  style="display: flex;">
  <!-- Modal content -->
  <div class="modal-content">
    <!-- <accordion  [isAnimated]="true" class="accordain-container-class">
      <h2 style="text-align: left;margin-bottom: 20px;">Terms of Use</h2>
      <accordion-group heading="1. Introduction" panelClass="customClass" >
        <div class="accordion-content">
          <p>
            This is a legal and binding agreement between you, the user (referred to as “user” or “you”) of the
            Programs, as
            defined
            below, and upGrad (together with its subsidiaries, and international affiliates, hereinafter "upGrad," "us,"
            "we," or
            "our" or “the Company”) stating the terms that govern your use of the Platform, as defined below. The
            website
            <a href="https://www.upgrad.com/" target="_blank">
              www.upgrad.com
            </a>
            and mobile apps (collectively referred to as the
            “Platform”) and
            the information, services and other
            materials contained therein are provided and operated by upGrad. upGrad offers curated and specially
            designed online
            higher education and industry-relevant certification programs and career assistance services (“Programs”).
          </p>
          <p>
            Please review our Terms of Use, Privacy Policy and other policies available on the Platform (collectively
            referred to
            as
            the “Terms”) that govern the use of the Platform and Programs. By accepting these Terms in any manner or
            accessing the
            website, you consent, agree, and undertake to abide, be bound by and adhere to the Terms and if you do not
            agree to
            these Terms, you are not entitled to avail of/use the Programs and any use thereafter shall be unauthorised.
          </p>
          <p>
            Each Program may have a separate set of terms dealing with refunds, deferrals, payments, etc. governing such
            Programs,
            and our corporate clients may have executed separate written agreements with us, which, in the event of a
            conflict, will
            supersede these Terms to the extent of the conflicting provisions.
          </p>
          <p>
            These Terms shall apply to upGrad hosted mobile apps, WhatsApp groups, Facebook groups, Instagram pages,
            Facebook pages,
            email/SMS/phone communications and other social media forums hosted by upGrad, which shall be deemed to be
            part of the
            ‘Platform’ by reference. You acknowledge that certain parts of the Platform, as mentioned above, are
            provided by
            third-party service providers, and you agree to abide by their terms and conditions. upGrad shall not be
            responsible for
            any disruption of services caused by such third-party service providers.
          </p>
          <p>
            Although you may "bookmark" a particular portion of the Platform and thereby bypass these Terms, your use of
            the
            Platform still binds you to these Terms.
          </p>
          <p>
            We may change these Terms from time to time without prior notice. You should review this page regularly.
            Your continued
            use of the Platform and Programs after changes have been made will be taken to indicate that you have read
            and accepted
            those changes. You should not use the Platform or Programs if you are not happy with any changes to these
            Terms.
          </p>
          <p>
            upGrad makes no representations that the Platform operates (or is legally permitted to operate) in all
            geographic areas,
            or that the Platform, or information, services or products offered through the Platform are appropriate or
            available for
            use in other locations. Accessing the Platform from territories where the Platform, or any content or
            functionality of
            the Platform or its portions thereof is illegal, is expressly prohibited. If you choose to access the
            Platform, you
            agree and acknowledge that you do so on your own initiative and at your own risk and that you are solely
            responsible for
            compliance with all applicable laws.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="2. User Accounts, User Registration and Delivery of Services" panelClass="customClass">
        <div class="accordion-content">
         <p>
          In order to participate in most Platform activities and to apply for a Program, you will need to register for a personal
          account (“User Account”) by undergoing a two-step verification process to verify your login credentials such as your
          phone number, by way of a one-time password which will be sent to your phone number simultaneously and/or by providing
          an email address and a password that is unique.
         </p>
          <p>
            Upon payment of the Program fees – in part or whole, depending on the Program – upGrad shall deliver the terms of use of
            the Program and grant you access to the Program. The invoice may be provided to you along with the email confirmation or
            within two (2) months thereafter. This shall be a proof of delivery against the successful payment of fees.
          </p>
          <p>
            Owing to certain exceptional circumstances, if upGrad has granted you access to a Program pending payment, and upGrad
            does not receive payments within the stipulated time periods, upGrad may, at its own discretion, withdraw your access to
            the Program without giving any prior notice.
          </p>
          <p>
            You agree that you will never divulge or share access to your User Account with any third party for any reason. You also
            agree that you will create, use and/or access only one User Account, and that you will not use any User Account other
            than your own.
          </p>
          <p>
            In setting up your User Account, you may be prompted or required to enter additional information, including but not
            limited to your name and email address. Additional information may be required to confirm your identity. You understand
            and agree that all information provided by you is accurate, current and complete and that you will maintain and update
            your information to keep it accurate, current and complete. You acknowledge that if any information provided by you is
            untrue, inaccurate, not current or incomplete, we reserve the right to terminate your use of the Platform and your
            enrolment into a Program, to the extent applicable.
          </p>
          <p>
            In addition to the registration process, as part of your use of the Platform or participation in the Programs, we may
            obtain certain information about you and your performance in the Programs. Some of this information may be Personally
            Identifiable Information. We may use, maintain, and store this information to provide certain services to you now and in
            the future, and may share such information with our Educational Partners or third parties in conjunction with such
            services or for the purpose of marketing. For example, as further detailed in our Privacy Policy, we may share certain
            materials or information about you with third parties, including your grades/scores in our classes. Irrespective of the
            fact if also you have registered yourself under DND or DNC or NCPR service, you still authorize us to give you a call
            from us or any third party for the above mentioned purposes till 365 days of your registration with us.
          </p>
         <p>
          Access to the Programs is restricted to attendees or students who have specifically been granted access by upGrad.
         </p>
         <p>
          By registering your User Account, you agree that:
         </p>
         <div>
          <ul>
            <li>
              you are registered for the Program only once and will not set up multiple User Accounts; and
            </li>
            <li>
              you will abide by these Terms and any terms specific to the Program.
            </li>
          </ul>
         </div>
         <p>
          Additional requirements apply to Students. As a Student, in addition to the points above, you agree that you are
          registering with the intent to complete the assignments, if any, that are relevant and applicable to the Platform or
          Programs into which you have enrolled.
         </p>
        </div>
      </accordion-group>
      <accordion-group heading="3. Payment Terms and Refund Policy" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Unless otherwise expressly agreed in writing by upGrad, full payment for participation in a Program is
            required at the
            time of registration. In the case of Programs that include a trial window, such trial window shall be made
            available
            only after the full payment. During the trial window, upon a request by the student, and to the satisfaction
            of upGrad,
            upGrad may, in accordance with the applicable refund policy for the particular Program, choose to refund the
            Program
            Fees paid, subject to deduction of such applicable charges for including but not limiting to administrative
            and
            marketing expenses, as may be decided by upGrad from time to time. Once the trial window is closed, there
            will be no
            refund allowed for any reason whatsoever. For all the program, where there is no trial window or preparatory
            session,
            refund shall be done in accordance with the terms and conditions of refund policy of the respective program.
          </p>
          <p>
            It is the sole responsibility of the user enrolling into a Program to check the accuracy of, and evaluate
            the
            suitability and relevance of, the Program elected. The enrolment into a Program is non-transferable.
          </p>
          <p>
            To make payment for any Program or to purchase any services or products offered by upGrad through the
            Platform, you must
            have internet access and a current valid accepted payment method as indicated during sign-up ("Payment
            Method"). upGrad
            does not store any of your credit card information or such other information restricted by the Reserve Bank
            of India
            (RBI) for processing payment and has partnered with payment gateways for the payment towards the services.
            By using a
            third-party payment provider, you agree to abide by the terms of such a payment provider. You agree that in
            case
            upGrad’s third-party payment provider stores any such information, upGrad will not be responsible for such
            storage, and
            it will be solely at your discretion to allow the third party to store such information. Any loss of such
            information or
            any loss incurred by you due to the usage of such information will be solely a loss incurred by you, and
            upGrad is in no
            way liable for any such losses and is neither responsible to reimburse / make good such losses in any manner
            whatsoever.
            You also agree to pay the applicable fees for the payments made through the Platform.
          </p>
          <p>
            upGrad or its representatives will not ask for OTP or other authentication related information for any
            purpose, and we
            urge you to be cautious while making payments and during financial transactions.
          </p>
          <p>
            Failure to pay the applicable Program fee may result in withdrawal of your access to a Program. Depending on
            where you
            transact with us, the type of payment method used and where your payment was issued, your transaction with
            us may be
            subject to foreign exchange fees or exchange rates. upGrad does not support all payment methods, currencies
            or locations
            for payment. All applicable taxes are calculated based on the billing information you provide to us at the
            time of
            enrolment/purchase.
          </p>
          <p>
            The cancellation of the program will be as per the refund policy. Each Program has specific refund terms
            which shall be
            applicable in case of refund on account of such cancellation requests.
          </p>
          <p>
            If you have subscribed for a free trial, the free trial period will last for the period of time specified
            during your
            sign-up. Free trials may not be combined with certain other offers. If you have subscribed to a particular
            paid service
            or product within the last six (6) months, or if your Payment Method, physical address, contact number or
            email address
            has been associated with an account for that paid service, you are not eligible to receive a free trial for
            that service
            or product. If you begin your subscription with a free trial, you may be ineligible for certain features of
            a product or
            service during your free trial period.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="4. Use of Programs" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad reserves the right to cancel or reschedule any Program or live lectures/webinars, or to alter, modify
            or
            rearrange the schedule of topics, as well as the point value or weight of assignments, tests, quizzes,
            exams, projects
            and other such evaluations of progress. You also understand that upGrad, at its sole discretion, may limit,
            suspend, or
            terminate your use of the Platform or Programs and/or all upGrad-provided services related to the Programs,
            such as
            access to upGrad coaches or support services, evaluation services, or certifications. You also understand
            that upGrad
            may modify or discontinue all services related to its Programs at its sole discretion. You agree that upGrad
            shall not
            be liable to you or to any third party for any such modification, suspension or discontinuance. Nothing in
            these Terms
            shall be construed to obligate upGrad to maintain and support the Platform or Programs or any part or
            portion thereof or
            any associated services.
          </p>
          <p>
            You agree that upGrad shall be under no liability whatsoever to you in the event of non-availability of the
            Platform or
            any portion thereof occasioned by Act of God, war, disease, revolution, epidemic, riot, civil commotion,
            strike,
            lockout, flood, fire, satellite failure, failure of any public utility, man-made disaster or any other cause
            whatsoever
            beyond the control of upGrad.
          </p>
          <p>
            Subject to the applicable refund policy, if you no longer wish to use any program, you may terminate your
            participation
            by giving a prior notice to upGrad. Participants of upGrad online live lectures and webinars shall be
            provided access to
            such classes via email. You agree not to share such access with any third party. If you are unable to attend
            an online
            live lecture/webinar, please provide upGrad with prior intimation regarding this.
          </p>
          <p>
            You shall be exclusively responsible for obtaining and maintaining any equipment or ancillary services
            needed to connect
            to, access, receive or use the Platform, including, without limitation, hardware devices, software, and
            other internet,
            wireless, broadband, phone and/or other mobile communication device connection services. You shall be
            exclusively
            responsible for ensuring that such equipment or ancillary services are compatible with the Platform, and you
            shall be
            responsible for all charges incurred in connection with the use of the Platform and Program in connection
            with all such
            equipment and ancillary services.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="5. Educational Partners and Accreditation" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad is NOT a university, but an education service provider, offering Programs in consultation with Indian
            and
            International universities, educational institutions, governmental authorities, NGOs, corporates, etc. (each
            an
            “Educational Partner”).
          </p>
          <p>
            Admission to the degree/diploma programs of an Educational Partner is separate from being accepted into
            and/or taking
            one or more Programs. You agree and acknowledge that nothing in these Terms or otherwise with respect to the
            use of the
            Platform or any Program (a) enrolls or registers you in an Educational Partner, or any other school,
            division, institute
            or program of or associated with an Educational Partner, and (b) allows you to access or use the resources
            or receive
            any benefits or privileges of any Educational Partner, beyond the Programs.
          </p>
          <p>
            upGrad may offer a credential or other acknowledgement for participants who have satisfactorily demonstrated
            mastery of the
            Program material. The decision to award any such credential acknowledgement to a given participant will be
            solely at the
            discretion of upGrad. upGrad may choose not to offer any credential or other acknowledgement for some
            Programs. upGrad
            may decide at its sole discretion whether to provide a record concerning a participant’s performance in a
            Program. The
            format of any credential or other acknowledgement, and of any performance, provided by upGrad relating to
            Programs will
            be determined by upGrad at its sole discretion and may vary from Program to Program.
          </p>
          <p>
            You will be awarded a certificate of successful completion of a Program (“Program Certificate”) only upon
            fulfilling the
            criteria and requirements of upGrad and its Educational Partners.
          </p>
          <p>
            If you are taking a Program for academic credit or certification as a student of, or otherwise through, an
            Educational
            Partner, any such credit or certification may only be awarded directly by the Educational Partner based on
            its own
            policies and procedures, and you may be required by that Educational Partner to be registered or enrolled
            with the
            Educational Partner in order to receive credit or certification; and, in any event, upGrad will not have any
            authority
            or responsibility with respect to any award of academic credit or certification provided by an Educational
            Partner for a
            Program.
          </p>
          <p>
            You acknowledge and agree that any Program affiliated with an Educational Partner may be subject to the
            terms, policies
            and procedures of the applicable Educational Partner in addition to upGrad’s Terms. Without limiting the
            foregoing, if
            you are a student registered or enrolled at, or are otherwise attending, an Educational Partner and are
            taking a Program
            for credit or certification through that Educational Partner, you acknowledge and agree that (a) the
            Educational Partner
            may have its own terms, policies or procedures regarding your eligibility to participate in the Program,
            your
            participation in the Program, the requirements or prerequisites for receiving credit or certification for
            the Program,
            and/or your educational or student records as they may relate to your participation and performance in the
            Program, and
            (b) your educational or student records are maintained by the Educational Partner, including for purposes of
            assigning
            credit or certification, and not upGrad.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="6. upGrad’s Intellectual Property Rights" panelClass="customClass">
        <div class="accordion-content">
          <p>
            “Content” means any and all information and data, which may include but not be limited to text, software,
            scripts,
            graphics, maps, photos, sounds, music, videos, logos, offers, advertisements, interactive features and other
            materials.
          </p>
          <p>
            The Platform, Programs and related services are owned and operated by upGrad and its licensors. All Content
            or other
            material available on the Platform or through the Programs, including but not limited to online/live
            lectures, speeches,
            video lessons, quizzes, presentation materials, homework assignments, programming assignments, programs,
            code, and other
            images, text, layouts, arrangements, displays, illustrations, documents, materials, audio and video clips,
            HTML and
            files (collectively “upGrad Content”), are the property of upGrad and/or its affiliates or licensors, and
            are protected
            by copyright, patent and/or other proprietary intellectual property rights under Indian and foreign laws.
            All software
            used on the Platform is the property of upGrad and is protected by Indian and international copyright laws.
          </p>
          <p>
            upGrad logos, trademarks and service marks that may appear on the Platform and in the Program (“upGrad
            Marks”) are the
            property of upGrad and are protected under Indian and foreign laws. All other trademarks, service marks and
            logos used
            on the Platforms, Online Courses or Programs, with or without attribution, are the trademarks, service marks
            or logos of
            their respective owners. In addition, elements of the Platforms are protected by trade dress and other
            Indian and
            international intellectual property laws and may not be copied, reproduced, downloaded or distributed in any
            way in
            whole or in part without the express written consent of upGrad.
          </p>
          <p>
            As a condition of accessing the Platforms and/or using the Programs, you agree not to (a) reproduce,
            duplicate, copy,
            sell, resell or exploit for any commercial purpose any upGrad Content or any portion of it thereof, other
            than as
            expressly allowed under these Terms; and (b) use the upGrad Marks or the name, trademarks, service marks, or
            other
            materials of any Educational Partner in connection with, or to transmit, any unsolicited communications or
            emails or for
            any other unauthorised purpose.
          </p>
          <p>
            Please verify all Content prior to use. In the event you come across any Content that is incorrect,
            infringing,
            offensive, indecent or objectionable, please notify us immediately at the address mentioned at the bottom of
            this page.
          </p>
          <p>
            Additionally, from time to time upGrad (or its third-party service providers, on behalf of upGrad) may
            request users to
            review upGrad Content or beta-test the Platform. The works derived from such activity shall remain the sole
            and
            exclusive property of upGrad or its third-party service providers, as applicable.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="7. Third-Party Intellectual Property" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad respects third-party intellectual property rights and actively supports protection of all third-party
            intellectual property including copyrights and trademarks (“IP”). It is our policy to expeditiously respond
            to clear
            notices of alleged IP infringement. If we receive proper notification of IP infringement, our response to
            such notices
            will include removing or disabling access to material claimed to be the subject of infringing activity.
          </p>
          <p>
            upGrad shall not be held liable for the unauthorised use of any third-party IP, and the user that carries
            out such
            unauthorised use or infringes any IP available on the Platform shall fully indemnify and hold upGrad
            harmless against
            any and all claims that may arise as a result of such use.
          </p>
          <div>
            <p>
              If you believe that your product or other work has been misrepresented or used in a way that constitutes
              copyright
              infringement, or your intellectual property rights have been otherwise violated, please provide us with
              the following
              information:
            </p>
            <ul>
              <li>
                an electronic or physical signature of the person authorised to act on behalf of the owner of the
                product,
                copyright or other intellectual property interest;
              </li>
              <li>
                a description of the product, work or other intellectual property that you claim has been misrepresented
                or infringed;
              </li>
              <li>
                a description of where the material that you claim is misrepresenting or infringing your product, work
                or other
                intellectual property is located on the Platform/Program;
              </li>
              <li>
                your address, telephone number, and email address;
              </li>
              <li>
                a statement by you that you have a good faith belief that the disputed use is not authorised by the
                owner of the
                product, work, copyright or intellectual property, or its agent, or applicable law; and
              </li>
              <li>
                a statement by you, made under the penalty of perjury, that the aforementioned information in your
                notice is accurate
                and that you are the product, work, copyright or intellectual property owner or authorised to act on
                such owner's
                behalf.
              </li>
            </ul>

          </div>
          <p>
            For notices of disputes or claims of copyright or other intellectual property infringement, please connect
            with us at
            the address provided at the bottom of this page.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="8. Limited License" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The services on the Platform are licensed, not sold. In consideration for your agreement to these Terms,
            upGrad grants
            you a personal, non-exclusive, non-transferable, revocable license to access and use the Platform and
            Programs, solely
            in accordance with the Terms. You may download or copy the portions of the upGrad Content available on the
            Platform for
            your own non-commercial and personal use only, provided you maintain all copyright and other notices
            contained in such
            upGrad Content. You may not copy, sell, resell, reproduce, publish, modify, transfer, retransmit,
            distribute,
            commercially exploit or create derivative works of Platforms, Programs or any upGrad Content.
            Notwithstanding the
            foregoing, certain reference documents, digital textbooks and articles may be made available to you with the
            permission
            of third parties, and use of that information is subject to certain rules and conditions, and you agree to
            abide by all
            such rules and conditions.
          </p>
          <p>
            You may not reverse-engineer, decompile, disassemble or otherwise access the source code for any software
            that may be
            used to operate the Platform or the Programs. From time to time, upGrad may include software, code,
            instructions, or
            other such information in the upGrad Content for the Programs; any such information is provided on an
            "as-is" basis for
            instructional purposes only and is subject to the ‘Disclaimer’ and ‘Limitation of Liability’ sections below
            and other
            terms herein. Any use of such information for commercial purposes is strictly prohibited. upGrad and/or its
            affiliates
            and licensors reserve all rights not expressly granted herein to the Platforms, upGrad Content, and UpGrad
            Marks.
          </p>
          <p>
            Without limiting the generality of the terms above, the following are types of uses that upGrad expressly
            defines as
            falling outside of the definition of "non-commercial and personal use":
          </p>
          <div>
            <ul>
              <li>
                the sale or rental of (i) any part of the upGrad Content, (ii) any derivative works based at least in
                part on the upGrad
                Content, or (iii) any collective work that includes any part of the upGrad Content;
              </li>
              <li>
                the sale of access or a link to any part of the upGrad Content;
              </li>
              <li>
                providing training, support, or editorial services that use or reference the upGrad Content in exchange
                for a fee;
              </li>
              <li>
                the use of upGrad Content by a college, university, school, or other educational institution for
                instruction where
                tuition is charged;
              </li>
              <li>
                the use of upGrad Content by a for-profit corporation or non-profit entity for internal professional
                development or
                training; and
              </li>
              <li>
                the use of upGrad Content for display / upload / making available at a place that is accessible to the
                general public in
                any manner, including but not limited to any social media sites, video download sites, and torrents.
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="9. User Conduct Policy" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Whether you have enrolled in a Program or are simply browsing the Platform, once you have accessed the
            Platform or
            Programs, you shall be considered a ‘user’ for the purpose of these Terms. You are responsible for all your
            activities
            in connection with the use of the Platform and Programs. You hereby agree to fully comply with all
            applicable local,
            provincial, state, national and foreign laws, treaties, and regulations in connection with such use. You
            shall not
            resort to any unethical practices while using the Platform.
          </p>
          <p>
            Without limitation, you will not post or transmit, or cause to be posted or transmitted, any communication
            or
            solicitation or other "phishing", "pharming" or "whaling" message designed or intended to obtain password,
            account,
            personal information, financial information, confidential information or private information from any user
            of the
            Platform or any other third party whatsoever. However, if any such event does take place, upGrad shall not
            be liable for
            any loss of data or if the user’s device, computer system or any other property is compromised in any
            manner.
          </p>
          <p>
            You acknowledge and agree that upGrad has the right to report any and all such suspicious or illegal
            activity to the
            appropriate legal or police authorities without notice to you.
          </p>
          <p>
            During your use of the Platform and Programs, you will:
          </p>
          <div>
            <ul>
              <li>
                not harass other users, students, attendees, support agents or visitors;
              </li>
              <li>
                not create an atmosphere of disharmony, hostility within student groups;
              </li>
              <li>
                not cheat on any homework assignment or exams for the Program;
              </li>
              <li>
                not post online any secured testing materials;
              </li>
              <li>
                not share solutions to homework assignments or exams; and
              </li>
              <li>
                notify the instructors immediately if you become aware of any other user cheating or breaching these
                Terms and comply
                with the requirements of the specific applicable code of conduct, if any, relating directly to a Program
                into which such
                user is enrolled.
              </li>
            </ul>
          </div>
          <p>
            upGrad is an intermediary with respect to User Content (defined under ‘User Content’) and any other post or
            comment or
            other information uploaded, published, transmitted or updated by you in accordance with Information
            Technology
            (Intermediary Guidelines and Digital Media Ethics Code) Rules 2021 and the laws of any other jurisdiction
            where upGrad
            would qualify as an intermediary. In furtherance of the same, You should not host, display, upload, modify,
            publish,
            transmit, store, update or share any information that:
          </p>
          <div>
            <ul>
              <li>
                belongs to another person and to which the user does not have any right;
              </li>
              <li>
                is defamatory, libellous, fraudulent, threatening, obscene, indecent, profane, pornographic,
                paedophilic, invasive of
                another’s privacy including bodily privacy, discriminating, harmful, insulting or harassing on the basis
                of gender,
                libellous, racially or ethnically objectionable, relating or encouraging money laundering or gambling,
                or otherwise
                inconsistent with or contrary to the laws in force;
              </li>
              <li>
                is harmful to child;
              </li>
              <li>
                infringes any patent, trademark, copyright or other proprietary rights;
              </li>
              <li>
                violates any law for the time being in force;
              </li>
              <li>
                deceives or misleads the addressee about the origin of the message or knowingly and intentionally
                communicates any
                information which is patently false or misleading in nature but may reasonably be perceived as a fact;
              </li>
              <li>
                impersonates another person;
              </li>
              <li>
                threatens the unity, integrity, defence, security or sovereignty of India, friendly relations with
                foreign States, or
                public order, or causes incitement to the commission of any cognisable offence or prevents investigation
                of any offence
                or is insulting other nation;
              </li>
              <li>
                contains software virus or any other computer code, file or program designed to interrupt, destroy or
                limit the
                functionality of any computer resource;
              </li>
              <li>
                is patently false and untrue, and is written or published in any form, with the intent to mislead or
                harass a person,
                entity or agency for financial gain or to cause any injury to any person;
              </li>
              <li>
                content that discusses illegal activities, with the intent to commit them;
              </li>
              <li>
                content that you do not have the right to disclose;
              </li>
              <li>
                advertising or any form of commercial solicitation;
              </li>
              <li>
                content related to partisan political activities;
              </li>
              <li>
                content that contains intentionally inaccurate information or that is posted with the intent of
                misleading others;
              </li>
              <li>
                including but not limited to viruses, Trojan horses, worms, time bombs, cancelbots, or other disabling
                devices or other
                harmful components intended to or that may damage, detrimentally interfere with, surreptitiously
                intercept, or
                expropriate any system, data, or personal information;
              </li>
              <li>
                content that consists of any high volume, automated, or electronic means to access the Platform
                (including without
                limitation robots, spiders or scripts);
              </li>
              <li>
                Content that violates the rights of other users of the Platform; or
              </li>
              <li>
                content that violates any applicable local, state, national or international law or otherwise advocates
                or encourages
                any illegal activity.
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="10. User Content" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The Platform may allow you to upload forum posts, chat with other users and upGrad’s counsellors, user
            discussions,
            profile pages, and other content and media for social interaction, or certain information and materials for
            use with the
            Programs, e.g., questions, hypotheticals, examples, assignments, industry projects, etc. (collectively "User
            Content").
            upGrad does not claim ownership of any User Content you may submit or make available for inclusion on the
            Platform or
            Programs. Accordingly, subject to the license granted to upGrad above, the user will be the sole and
            exclusive owner of
            any and all rights, title and interest in and to the User Content.
          </p>
          <p>
            With respect to any User Content you submit via the Platform or Programs or that is otherwise made available
            to upGrad,
            you hereby grant upGrad an irrevocable, worldwide, perpetual, royalty-free and non-exclusive license to use,
            distribute,
            reproduce, modify, adapt, publicly perform and publicly display such User Content on the Platforms or in the
            Programs or
            otherwise exploit the User Content, with the right to sublicense such rights (to multiple tiers), for any
            purpose
            (including for any commercial purpose). upGrad reserves the right to remove any User Content at any time and
            for any
            reason.
          </p>
          <p>
            To the extent that you provide any User Content, you represent and warrant that (a) you have all necessary
            rights,
            licenses and/or clearances to provide such User Content and permit upGrad to use such User Content as
            provided above,
            (b) such User Content is accurate and reasonably complete, (c) as between you and upGrad, you shall be
            responsible for
            the payment of any third-party fees related to the provision and use of such User Content, and (d) such User
            Content
            does not and will not infringe or misappropriate any third-party rights or constitute a fraudulent statement
            or
            misrepresentation or unfair business practices.
          </p>
          <p>
            upGrad does not control the User Content posted through the Platform, including any messages, reviews or
            comments, and
            does not guarantee the accuracy, integrity or quality of such User Content. Under no circumstances will
            upGrad be liable
            in any way for any User Content, including any errors or omissions, or any loss or damage or defamation of
            any kind
            incurred as a result of your posting or use of any User Content. You are responsible for complying with all
            the laws
            applicable to the User Content.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="11. Platform Security" panelClass="customClass">
        <div class="accordion-content">
          <p>
            You are prohibited from violating or attempting to violate the security of the Platform or any other
            associate Platform
            of upGrad, including, without limitation, (a) accessing data not intended for such user or logging onto a
            server or an
            account that the user is not authorised to access; (b) attempting to probe, scan or test the vulnerability
            of a system
            or network or to breach security or authentication measures without proper authorisation; (c) attempting to
            interfere
            with service to any user, host or network, including, without limitation, via means of submitting a virus to
            the
            Platform, overloading, "flooding," "spamming," "mailbombing" or "crashing;" (d) sending unsolicited emails,
            including
            promotions and/or advertising of products or services; or (e) forging any TCP/IP packet header or any part
            of the header
            information in any email or newsgroup posting. Violations of system or network security may result in civil
            or criminal
            liability. upGrad will investigate occurrences that may involve such violations and may involve, and
            cooperate with, law
            enforcement authorities in prosecuting users who are involved in such violations. You agree not to use any
            device,
            software or routine to interfere or attempt to interfere with the proper working of this Platform or any
            activity being
            conducted on the Platform. You agree, further, not to use or attempt to use any engine, software, tool,
            agent or other
            device or mechanism (including without limitation browsers, spiders, robots, avatars or intelligent agents)
            to navigate
            or search the Platform other than the search engine and search agents available from upGrad on the Platform
            and other
            than generally available third-party web browsers (e.g., Google Chrome or Microsoft Explorer).
          </p>
          <p>
            upGrad strives to ensure the security of its users and has implemented measures to protect the security of
            user accounts
            and related information. However, we cannot guarantee that unauthorized third parties will not be able to
            breach our
            security measures.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="12. Disclaimer" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The Platform and/or Programs may contain typographical errors or inaccuracies and may not be complete or
            current.
            upGrad, therefore, reserves the right to correct any errors, inaccuracies or omissions (including after an
            order has
            been submitted) and to change or update information at any time without prior notice.
          </p>
          <p>
            The Platform, Programs, and any information or upGrad Content are provided on an “as is” and “as available”
            basis with
            all faults.
          </p>
          <p>
            upGrad makes no representations or warranties of any kind, whether expressed or implied, with respect to
            upGrad Content
            or services available on or through this Platform and Programs, including, but not limited to, the implied
            warranties of
            merchantability, fitness for a particular purpose, and non-infringement. upGrad makes no warranty that the
            services will
            meet the user's requirements or that the services will be uninterrupted, timely, secure, or error free; nor
            does upGrad
            make any warranty as to the results that may be obtained from the use of the services, or as to the accuracy
            or
            reliability of any information obtained through the services, or that any defects in the software will be
            corrected.
          </p>
          <p>
            The user understands and agrees that the upGrad Content and all other information, data, or other material
            downloaded or
            otherwise obtained through or from the Platform or Programs is obtained at the user's own discretion and
            risk, and that
            the user will be solely responsible for any damage to the user, the user's computer system, electronic
            device or any
            loss of data that results from the download of such material or data.
          </p>
          <p>
            You may find information on availability of EMI options or loans for payment of your program fees on the
            Platform for
            certain programs. Please note this is for information purposes only and the loan facilities are provided by
            third party
            credit facility providers and upGrad is not privy to any arrangement you may enter into with them. You will
            be bound by
            the terms and conditions of your agreement or arrangement with such third party credit facility providers
            and upGrad
            will not in any way be liable or responsible for or in relation to any such arrangements.
          </p>
          <p>
            Under no circumstances will upGrad be liable in any way for use of any upGrad Content or any other
            information, data, or
            other material downloaded or otherwise obtained through or from the Platform or Programs , including any
            errors or
            omissions, or any loss or damage or defamation of any kind incurred as a result of your use of or reliance
            on such
            information or data. -No advice or information, whether oral or written, obtained by the user from upGrad or
            through or
            from the services, shall create any warranty by upGrad.
          </p>
          <p>
            In the event you find any information provided on the Platform or Programs incorrect or obscene , or if you
            are the
            owner of any information or content and wish that such information or content is not displayed on the
            Platform or
            Programs, kindly notify us at the address provided at the bottom of the page.
          </p>
          <p>
            Testimonials, reviews and success stories including but not limited to regarding hike in salary, promotions,
            etc.
            appearing on the Platform are individual experiences, reflecting real life experiences of those that have
            used our
            products and/or services in some way or another. However, they are individual results and results may vary.
            We do not
            claim that they are typical results that consumers will generally achieve. The testimonials are not
            necessarily
            representative of all of those who will use our products and/or services.
          </p>
          <p>
            The testimonials, reviews and success stories presented on the Platform are applicable to the individuals
            writing them and
            may not be indicative of future performance or success of any other individuals. upGrad cannot and does not
            guarantee
            results.
          </p>
          <p>
            There might be trademarks, logos and brand names of other companies including EPs featured or referred on
            the website
            (“Third Party IP”). Use of these names, trademarks and brands or Third Party IP does not imply endorsement.
            These are
            the property of their respective trademark holders.
          </p>
          <p>
            You may not use any of these Third Party IP, or any variations thereof, without the owner's prior written
            consent. You
            may not use any of these Third Party IP or any variations thereof, for promotional purposes, or in any way
            that
            deliberately or inadvertently claims, suggests or, in the owner’s sole judgment, gives the appearance or
            impression of a
            relationship with or endorsement by the owner.
          </p>
          <p>
            Nothing contained on the Platform should be construed as granting, by implication, estoppel, or otherwise,
            any license
            or right to use any Third Party IP displayed on the Platform without the written permission of the owner of
            the
            applicable Third Party IP.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="13. Program Related Disclaimers" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad does not grant credit. Credits are granted, accepted or transferred at the sole discretion of the
            relevant
            educational institution offering the program.
          </p>
          <p>
            upGrad does not make any representations regarding the recognition or equivalence of the credits or
            credentials awarded,
            except as provided in the offer letter issued to you. We advise you to enquire further regarding the
            suitability of a
            particular program offered on the Platform for your academic and professional requirements before enrolling.
          </p>
          <p>
            Admission to the Masters courses offered under certain dual programs is contingent upon you meeting the
            terms and
            conditions mentioned in the offer letter issued to you. upGrad does not guarantee admission into the Masters
            course
            offered under any program offered on the Platform or any other degree program.
          </p>
          <p>
            If you intend to pursue a doctorate degree upon completion of a program or apply for employment which
            requires specific
            credits or credentials, we advise you to enquire further regarding the suitability of the particular program
            for your
            academic and/or professional requirements before enrolling.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="14. Limitation of Liability" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Neither upGrad nor any of its Educational Partners, affiliates, employees, directors, officers, agents,
            vendors or
            supplier shall be liable to you or any other person, whether in Tort, Contract, Strict Liability or
            otherwise, for any
            indirect, special, incidental or consequential losses or damages of any nature arising out of or in
            connection with the
            use or inability to use this Platform or Programs, including, without limitation, damages for lost profits,
            loss of
            goodwill, loss of data, work stoppage, accuracy of search results, or computer / electronic device failure,
            virus or
            malfunction. In no event will upGrad be liable for any damages in excess of ₹1000 or, in the case of
            enrolled students,
            the fees paid by you in connection with your enrolment into a Program.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="15. Site Linking" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The Platform may contain links to pages on other websites ("Linked Sites"), and those Linked Sites may
            contain Content
            or offer products and/or services for sale. upGrad does not author, edit, control, or monitor these Linked
            Sites. You
            acknowledge and agree that (a) we have no responsibility for the accuracy or availability of information
            provided by
            Linked Sites; (b) we do not control or endorse the sponsors of such Linked Sites or the content, products,
            advertising,
            or other materials presented on such Linked Sites; and (c) you agree to the terms and conditions of the
            Linked Sites. We
            may remove any Linked Sites from the Platform at any time with or without reason.
          </p>
          <p>
            UPGRAD WILL NOT BE LIABLE FOR ANY TRANSACTIONS CONDUCTED BY YOU WITH THIRD PARTIES THROUGH THE LINKED SITES
            OR FOR ANY
            LIABILITY ARISING FROM THE REPRESENTATIONS OR INFORMATION PROVIDED ON SUCH LINKED SITES.
          </p>
          <p>
            We appreciate that Linked Sites may contain material on which the operator of the Linked Sites has
            intellectual property
            rights. We respect those rights and provide the links for information purposes only. The fact that we have
            provided
            links to any Linked Site does not create or imply any relationship or partnership with the operator of such
            Linked Site.
          </p>
          <p>
            You may not establish a link to this Platform from any other website, application, intranet or extranet site
            without our
            prior written consent. If you wish to create links, you may contact us before doing so. In establishing
            links, you must
            not represent in any way, expressly or by implication, that you have received the endorsement, sponsorship
            or support of
            upGrad, including its Educational Partners, respective employees, agents, directors, officers or
            shareholders.
          </p>
          <p>
            The Platform uses YouTube API Services to play YouTube videos. When you visit the Platform and play videos
            from YouTube,
            your use of the Platform means that you agree to be bound by YouTube's Terms of Service, which is available
            at
            <a href="https://www.youtube.com/t/terms" target="_blank">
              https://www.youtube.com/t/terms
            </a>.
          </p>
          <p>
            We take no responsibility for the content or practices of any third-party services in the Linked Sites.
          </p>
          <p>
            We encourage you to carefully review the terms of services/use of any third-party services or Linked Sites
            you access.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="16. Indemnity" panelClass="customClass">
        <div class="accordion-content">
          <p>
            You agree to indemnify and hold upGrad and its Educational Partners harmless from any and all claims,
            liabilities,
            damages, losses and expenses, including reasonable attorneys' fees and costs, relating to or arising out of
            (a) your use
            or attempted use of the Platforms or Programs in violation of the Terms; (b) your violation of any law or
            rights of any
            third party; or (c) information or Content that you or others post or otherwise make available on the
            Platform or
            through any Program, including without limitation any claim of infringement or misappropriation of
            intellectual property
            or other proprietary rights.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="17. Termination of Rights" panelClass="customClass">
        <div class="accordion-content">
          <p>
            You agree that upGrad, in its sole discretion, may deactivate your account or otherwise terminate your use
            of the
            Platform or enrolment to a Program with or without reason, including, without limitation, if upGrad believes
            that you
            have (a) breached the Terms; (b) infringed the intellectual property rights of a third party; (c) posted,
            uploaded or
            transmitted unauthorised Content on the Platform; or (d) violated or acted inconsistently with the letter or
            spirit of
            these Terms or any other applicable code of conduct. You agree that any deactivation or termination of your
            access to
            the Platforms or Programs may be effected without prior notice to you and that upGrad shall not be liable to
            you nor any
            third party for any termination of your account or enrolment into a Program. You also acknowledge that
            upGrad may retain
            and store your information on upGrad’s systems notwithstanding any termination of your account or enrolment
            into the
            Programs.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="18. Miscellaneous Provisions" panelClass="customClass">
        <div class="accordion-content">
          <p>
            By accepting the Terms through your use of the Platform, you certify that you are 18 years of age or older.
            If you are
            under the age of 18 or under the legal age in your jurisdiction to enter into a binding contract, you may
            use the
            Platform only under the supervision of a parent or legal guardian who agrees to be bound by the Terms. If
            you are a
            parent or legal guardian agreeing to the Terms for the benefit of a child below 18, be advised that you are
            fully
            responsible for his/her use of the Platform, including all financial charges and legal liability that he/she
            may incur.
            By using the Platform, you represent and warrant that you have the right, authority, and capacity to enter
            into the
            Terms and to abide by all of the terms and conditions set forth herein. The Programs are not for the use of
            individuals
            under the age of 18 years.
          </p>
          <p>
            upGrad may freely transfer or assign any portion of its rights or delegate its obligations under these Terms
            or any Program
            specific terms. You shall not transfer or assign, by operation of law or otherwise, any portion of your
            rights or
            delegate your obligations under these Terms or any Program-specific terms without the prior written consent
            of upGrad.
          </p>
          <p>
            These Terms or any Program-specific terms shared with you shall be governed by, construed and enforced in
            accordance
            with the laws in India, as these are applied to agreements entered into and to be performed entirely within
            India and
            without giving effect to any principles of conflict of laws. You agree that any legal lawsuit or other
            action brought by
            upGrad, you or any third party to enforce these Terms or any Program-specific terms shared with you, or in
            connection
            with any matters related to the Platform or Programs, shall be subject only to the jurisdiction of the
            courts of Mumbai.
            Where a dispute arises, the parties involved shall make all reasonable efforts to resolve the dispute
            through good faith
            negotiations. If efforts to amicably resolve any dispute or claim between the parties are unsuccessful, then
            such
            dispute or claim arising out of or in connection with the Terms or any Program-specific terms shared with
            you, including
            any question regarding its existence, validity or termination, shall be referred to arbitration under the
            Arbitration
            and Conciliation Act, 1956, as amended (“Act”) before a sole arbitrator to be appointed by upGrad. The
            proceedings shall
            be conducted in English and the seat for arbitration shall be Mumbai.
          </p>
          <p>
            If any provision of the Terms or any Program-specific terms shared with you is found to be unlawful, void,
            or for any
            reason unenforceable, then that provision shall be deemed severable from the other provisions herein, and
            shall not
            affect the validity and enforceability of any remaining provisions. upGrad shall have no liability under
            these Terms or
            any Program-specific terms shared with you, to the extent arising from any failure of upGrad to perform any
            of its
            obligations under these Terms or any Program-specific terms shared with you, due to any fire, flood,
            earthquakes, other
            acts of God, war, civil unrest, terrorism, Internet failures, governmental act or court order, national
            emergency,
            strikes or labour disputes or any other event not within upGrad's reasonable control. upGrad shall not be
            responsible
            for damage or other problems caused by any unauthorised change to these Terms made by way of hacking or
            cracking this
            page.
          </p>
          <p>
            The failure of upGrad to exercise or enforce any right or provision of the Terms or any Program-specific
            terms shared
            with you, shall not constitute a waiver of such right or provision. If any provision of the Terms or any
            Program-specific terms shared with you is found by a court of competent jurisdiction to be invalid, the
            parties
            nevertheless agree that the court should endeavour to give effect to the parties' intentions as reflected in
            the
            provision, to the extent that may lawfully be done, and the other provisions of these Terms or any
            Program-specific
            terms shared with you, shall remain in full force and effect.
          </p>
          <p>
            These Terms or any Program-specific terms shared with you constitute the entire agreement between you and
            upGrad
            relating to the matters set forth herein, and shall not be modified except in writing, as posted on the
            Platforms by
            upGrad or through a specific writing between you and upGrad.
          </p>
          <p>
            upGrad may freely transfer or assign any portion of its rights or delegate its obligations under the Terms
            or any
            Program-specific terms shared with you. You may not transfer or assign, by operation of law or otherwise,
            any portion of
            your rights or delegate your obligations under the Terms or any Program-specific terms shared with you,
            without the
            prior written consent of upGrad, and any such attempted transfer or assignment shall be void and of no
            effect.
          </p>
          <p>
            In the event if you feel that your concern has not been resolved to your satisfaction, you may contact our
            grievance
            officer, who shall endeavour to redress the concern within 30 working days from the date of escalation. You
            are advised
            to escalate to the grievance officer only when you have already raised your complaint which has not been
            resolved to
            their satisfaction, or their concern has not been resolved within 30 working days from the date of ticket
            generation.
          </p>
          <p>
            In compliance of the Information Technology Act, 2000 and rules made thereunder and also in compliance of
            the Consumer
            Protection (E-Commerce) Rules, 2020 the name and contact details of the Grievance Officer are herein as
            under:
          </p>
          <p>
            <strong>Grievance Officer:</strong>: <span>Arpita Patel</span>
          </p>
          <p>
            To raise any grievance with us, please click on the following link:
            <a href="https://programs.upgrad.com/complaint-forum" target="_blank">
              <strong>
                Grievance Redressal Form
              </strong>
            </a>
          </p>
          <p>
            Or
          </p>
          <p>
            Write to
            <a href="mailto:grievance.redressal@upgrad.com">
              <strong>
                grievance.redressal@upgrad.com
              </strong>
            </a>
          </p>
          <p>
            Or
          </p>
          <p>
            Contact us at For Indian Learners - 1800 210 2020 & For International Learners - +918045604032
          </p>
          <p>
            In compliance with the Consumer Protection Act 2019, upGrad has appointed a Nodal Officer who can be
            contacted in case
            of any consumer grievances or queries. The name and email ID of our Nodal Officer are as follows:
          </p>
          <p>
            Nodal Officer: Arpita Patel
          </p>
          <p>
            Email ID:
            <a href="mailto:grievance.redressal@upgrad.com">
              <strong>
                grievance.redressal@upgrad.com
              </strong>
            </a>
          </p>
          <p>
            Any notice or communication that may be required to be given to UpGrad under these Terms or any
            Program-specific terms
            shared with you may be sent by writing or emailing to the following addresses:
          </p>
          <p>
            upGrad Education Private Limited<br />
            3rd Floor CTS-796-A, Fleet Building Vlg. MA, Opp.<br />
            Marol Fire Station, Sir M.V. Road, Marol, Andheri (East),<br />
            Marol Naka, Mumbai, Maharashtra, India --- 400059
          </p>
          <p>
            Phone: 022 61562100<br />
            CIN - U80902MH2012PTC258559<br />
          </p>
        </div>
      </accordion-group>
      <h2 style="text-align: left;margin-bottom: 20px;margin-top: 20px;">Privacy Policy</h2>
      <accordion-group heading="1. Introduction" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad (together with its subsidiaries, and international affiliates, hereinafter "upGrad ," "us," "we," or
            "our" or
            “the Company”) is committed to security and management of personal data, to function effectively and
            successfully for
            the benefit of our stakeholders, customers and for the community. In doing so, it is essential that people’s
            privacy is
            protected through the lawful and appropriate means for handling the personal data. Therefore, we have
            implemented this
            privacy policy (hereinafter referred to as ‘‘policy’’).
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="2. Aim" panelClass="customClass">
        <div class="accordion-content">
          <p>
            This policy aims to protect personal data of the various stakeholders connected to our organization. This
            policy is
            aimed at providing individuals notice of the basic principles by which the company processes the personal
            data of
            individuals (“Personal Data”) who visits, uses, deals with and/or transacts through the website and includes
            a guest
            user and browser (hereinafter ‘you’, ‘user’).
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="3. Purpose and Scope" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The purpose of this policy is to describe how upGrad collects, uses, and shares information about you
            through our online
            interfaces (e.g., websites and mobile applications) owned and controlled by us, including but not limited to
            <a href="https://www.upgrad.com/" target="_blank">
              https://www.upgrad.com/
            </a>
            (hereinafter the "website"). This policy is
            also designed to provide information on how upGrad
            ensures data security, conducts data transfers and process requests from data subjects.
          </p>
          <p>
            This policy control applies to all systems, people and processes that constitute the organization’s
            information systems,
            including board members, directors, employees and other third parties who have access to Personal Data
            available within
            upGrad.
          </p>
          <p>
            The company is also committed to ensure that its employees conduct themselves in line with this, and other
            related,
            policies. Where third parties process data on behalf of upGrad, the Company endeavours to obtain assurances
            from such
            third parties that your Personal Data will be safeguarded consistently.
          </p>
          <p>
            upGrad offers curated and specially designed higher education and industry-relevant certification programs
            online
            (“hereinafter individually or collectively referred to as Program”). This Privacy Policy applies to all our
            services
            unless specified otherwise.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="4. Types of Personal Data collected" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The Personal Data that we collect about you depends on the context of your interactions with us, the
            products, services
            and features that you use, your location, and the applicable laws.
          </p>
          <p>
            Personal Data is stored in personnel files or within the electronic records (on servers in India or other
            countries) of
            upGrad. The following types of Personal Data may be held by the Company, as appropriate, on relevant
            individuals:
          </p>
          <p>
            A. Personal Identification Data
          </p>
          <div>
            <ul>
              <li>
                First Name, Last name
              </li>
              <li>
                Job title & Company
              </li>
              <li>
                Signature
              </li>
              <li>
                Photographs
              </li>
            </ul>
          </div>
          <p>
            B. Identification Data
          </p>
          <div>
            <ul>
              <li>
                Social security or tax identification numbers
              </li>
              <li>
                Aadhar number and PAN
              </li>
            </ul>
          </div>
          <p>
            C. Financial Data
          </p>
          <div>
            <ul>
              <li>
                Bank Account information
              </li>
              <li>
                Salary Information
              </li>
              <li>
                Payment gateway account details
              </li>
              <li>
                E-wallet account details
              </li>
            </ul>
          </div>
          <p>
            D. Personal Characteristics
          </p>
          <div>
            <ul>
              <li>
                Age
              </li>
              <li>
                Gender
              </li>
              <li>
                Date of Birth
              </li>
              <li>
                Marital Status
              </li>
              <li>
                Nationality
              </li>
            </ul>
          </div>
          <p>
            E. Contact Data
          </p>
          <div>
            <ul>
              <li>
                Postal address
              </li>
              <li>
                Email address
              </li>
              <li>
                Phone number
              </li>
            </ul>
          </div>
          <p>
            F. Education and Recruitment Data
          </p>
          <div>
            <ul>
              <li>
                Educational qualification(s)
              </li>
              <li>
                Working goals
              </li>
              <li>
                Post-qualification experience
              </li>
            </ul>
          </div>
          <p>
            G. Electronic Identification Data
          </p>
          <div>
            <ul>
              <li>
                Login credentials (If you are a registered user)
              </li>
              <li>
                Visitors IP Data
              </li>
              <li>
                Date and time of website visit
              </li>
              <li>
                Pages visited and navigation on the website
              </li>
              <li>
                Browser being used
              </li>
              <li>
                County of accessing website
              </li>
              <li>
                Language of the browser being used
              </li>
              <li>
                Words searched for
              </li>
              <li>
                Pixel tags
              </li>
            </ul>
          </div>
          <p>
            H. Inquiries
          </p>
          <div>
            <ul>
              <li>
                Personal Data stated in the form – for example: Name, address, phone number, country
              </li>
              <li>
                Subject of Inquiry
              </li>
              <li>
                Personal details (Name on the card, billing address)
              </li>
              <li>
                Payment details (card numbers, card type)
              </li>
              <li>
                Recordings of calls with students and users showing interest in our Program.
              </li>
              <li>
                Information about your interactions with customer service and maintenance interactions with us.
              </li>
            </ul>
          </div>
          <p>
            I. User Generated Data
          </p>
          <div>
            <ul>
              <li>
                Projects and Assignments submitted
              </li>
              <li>
                Peer feedback and grading
              </li>
              <li>
                Program performance data
              </li>
              <li>
                Response to quizzes, standalone quizzes, exams, and surveys
              </li>
              <li>
                Web Cam Recordings (during assessments related to online courses)
              </li>
              <li>
                Posts made to public forums through our platform
              </li>
              <li>
                Any other information necessary to ensure conformity with test/ assessment rules, area of interests
              </li>
            </ul>
          </div>
          <p>
            J. Marketing Data
          </p>
          <div>
            <ul>
              <li>
                Your preferences in receiving marketing information from us
              </li>
              <li>
                Your communication preferences
              </li>
            </ul>
          </div>
          <p>
            K. Behavioural Data
          </p>
          <div>
            <ul>
              <li>
                Data inferred or assumed information relating to your behaviour and interests based on your online
                activity on our
                sites
              </li>
            </ul>
          </div>
          <p>
            We do not collect any payments information processed by third-party payment gateway providers.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="5. Special Categories of Personal Data" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Special Category of Personal Data includes details about your race or ethnicity, religious or philosophical
            beliefs, sex
            life, sexual orientation, political opinions, trade unions memberships, information about your health and
            genetic and
            biometric data.
          </p>
          <p>
            We do not collect or process any special or sensitive Personal Data.
          </p>
          <p>
            Should we specifically require “special” or “sensitive” Personal Data in connection with one or more of the
            uses
            described below, we will request your explicit consent to use the data in accordance with this policy and/or
            in the ways
            described at the point where you were asked to disclose the data.
          </p>
          <p>
            Other legal basis for our processing of special category data may include, as permitted by applicable law,
            for
            scientific research, for employment, social security or social protection law, for reasons of substantial
            public
            interest, or as necessary for the establishment, exercise or defence of legal claims. If you voluntarily
            share with us
            or post/upload any “special” or “sensitive” Personal Data to this website for any other reason, you consent
            that we may
            use such data in accordance with applicable law and this policy. You can contact our DPO for more
            information about our
            processing of your Personal Data.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="6. Sources of data collection" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The data collected by the company is derived directly from the data provided by the user or by use of our
            sites.
          </p>
          <p>
            Data Collected when You:
          </p>
          <div>
            <ul>
              <li>
                Register for various seminars, webinars or any other outreach initiatives made available by us or
                Educational Partner’s
                offline activities
              </li>
              <li>
                Request a quote for the various products and services offered by us
              </li>
              <li>
                Place a feedback, complete any customer surveys circulated or interact with our customer services online
              </li>
              <li>
                View our services or visit our website pages on the internet
              </li>
              <li>
                Browse our website
              </li>
              <li>
                When you appear for assignments, exams or any other assessments in relation to online course
              </li>
              <li>
                When you avail scholarships, refunds and referrals
              </li>
            </ul>
          </div>
          <p>
            Data Collected from third parties
          </p>
          <p>
            We receive Personal Data such as access or login details, profile picture or any other text / image in
            relation to your
            Personal Data which may be available with such third parties.
          </p>
          <p>
            We also receive information about your visits to this platform and to other websites using pixel tags.
          </p>
          <p>
            Third parties from whom we receive your Personal Data include, our service providers, other networks
            connected to our
            service, our advertising partners, our marketing and advertising affiliates, our educational partners,
            scholarship
            providers, analytics providers, recruiters and such other third-party sources.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="7. Cookie" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Cookies are text files placed on your computer to collect standard Internet log information and visitor
            behaviour
            information. When you visit our websites, we may collect information from you automatically through cookies
            or similar
            technology.
          </p>
          <p>
            Furthermore, we may allow third-party advertising companies (such as Facebook, Google, Twitter, Quora and
            Bing) to place
            cookies on our website. These cookies enable such companies to track your activity across various sites
            where they
            display Ads and record your activities, so they can show Ads that they consider relevant to you as you
            browse the
            Internet. These cookies store information about the content you are browsing, together with an identifier
            linked to your
            device or IP address.
          </p>
          <p>
            <strong>
              How do we use cookies?
            </strong>
          </p>
          <p>
            upGrad uses cookies in a range of ways to improve your experience on our website, including:
          </p>
          <div>
            <ul>
              <li>
                To recognize our website user and to enhance user experience when interacting with our website
              </li>
              <li>
                We moreover use cookies to help us to analyse the use and performance of our website and services
              </li>
              <li>
                We also use cookies to improve the delivery and value of various services and products offered by us.
              </li>
            </ul>
          </div>
          <p>
            <strong>
              What types of cookies do we use?
            </strong>
          </p>
          <p>
            There are a few different types of cookies, however, our website uses:
          </p>
          <div>
            <ul>
              <li>
                Persistent Cookies. We use persistent Cookies to improve your experience of using the Sites. This
                includes recording
                your acceptance of our Cookie Policy to remove the cookie message which first appears when you use the
                Sites.
              </li>
              <li>
                Session Cookies. Session Cookies are temporary and deleted from your machine when your web browser
                closes. We use
                session Cookies to help us track internet usage as described above.
              </li>
              <li>
                Analytical/Performance Cookies. Analytical cookies allow us to recognise and count the number of
                visitors and see how
                many visitors move around our website while they are using it. This helps us improve the way our website
                works, for
                example, by ensuring the users find what they are looking for.
              </li>
              <li>
                Functionality Cookies. Functionality Cookies recognise when you return to the website. This enables the
                company to
                create greater content for you and remember your likes and dislikes and other preferences.
              </li>
              <li>
                Targeting Cookies. Targeting Cookies records the visit to our website, the pages navigated to and the
                links clicked
                upon. It helps to formulate information relevant to the user’s area of interests.
              </li>
            </ul>
          </div>
          <p>
            <strong>
              How to manage cookies?
            </strong>
          </p>
          <p>
            Most browsers allow you to refuse to accept cookies and to delete cookies. The methods for doing so vary
            from browser to
            browser, and from version to version. Disabling some cookies form the website, may have a negative impact
            and may result
            in some non-availability of some features.
          </p>
          <p>
            If you want to remove previously stored Cookies, you can manually delete the Cookies at any time. However,
            this will not
            prevent the Sites from placing further Cookies on your device unless and until you adjust your Internet
            browser setting
            as described above.
          </p>
          <p>
            You can however obtain up-to-date information about blocking and deleting cookies via these links:
          </p>
          <div>
            <ul>
              <li>
                <a href="https://support.google.com/chrome/answer/95647" target="_blank">
                  https://support.google.com/chrome/answer/95647
                </a>
                (Chrome)
              </li>
              <li>
                <a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" target="_blank">
                  https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences
                </a>
                (Firefox)
              </li>
              <li>
                <a href="https://www.opera.com/help/tutorials/security/cookies/" target="_blank">
                  https://www.opera.com/help/tutorials/security/cookies/
                </a>
                (Opera)
              </li>
              <li>
                <a
                  href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank">
                  https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies
                </a>
                (Internet Explorer)
              </li>
              <li>
                <a href="https://support.apple.com/kb/PH21411" target="_blank">
                  https://support.apple.com/kb/PH21411
                </a> (Safari)
              </li>
            </ul>
          </div>
          <p>
            These opt-out mechanisms rely on cookies to remember your choices. If you delete your cookies, use another
            computer or
            device, or change browsers, you will need to repeat this process. In addition, opting out of interest-based
            ads will not
            opt you out of all ads, but rather only those ads that are personalized to your interests.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="8. Data Analytics" panelClass="customClass">
        <div class="accordion-content">
          <p>
            We use Analytics tools and search information providers to measure how visitors interact with content on our
            website. We
            also use Facebook Custom Audiences to ask Facebook to show you ads that are customized based on your
            interaction with
            our websites or our Facebook applications and to measure how you interact with those ads. Additional
            information on how
            these services use such technologies can be found on Google’s website, Adobe’s website and Facebook’s
            website.
          </p>
          <p>
            If you do not wish to have data relating to your visits to our websites collected through Google Analytics,
            you may
            opt-out by installing the
            <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">
              Google Analytics opt-out
              browser add-on
            </a>
            . You may opt-out of Facebook Custom Audiences by
            visiting Facebook’s opt-out page.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="9. Aggregated Data" panelClass="customClass">
        <div class="accordion-content">
          <p>
            “Aggregated Data” means records that have been stripped of Personal Data and has been manipulated or
            combined to provide
            generalised, anonymous information. Your identity and personal information are not available in Aggregated
            Data. We
            combine your Personal Data on an anonymous basis with other information to generate Aggregated Data for
            internal and
            commercial use and for sharing with affiliates, subsidiaries and business partners for planning and
            marketing purposes.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="10. Data protection principles" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Where third parties process data on behalf of upGrad, we endeavour to obtain assurances from such third
            parties that
            your Personal Data will be safeguarded consistently. We understand that it will be accountable for the
            processing,
            management and regulation, and storage and retention of all Personal Data held in the form of manual records
            and on
            computers.
          </p>
          <p>
            All Personal Data obtained and held by the Company will:
          </p>
          <div>
            <ul>
              <li>
                be processed fairly, lawfully and in a transparent manner
              </li>
              <li>
                be collected for specific, explicit, and legitimate purposes
              </li>
              <li>
                be adequate, relevant and limited to what is necessary for the purposes of processing
              </li>
              <li>
                be kept accurate and up to date. Every reasonable effort will be made to ensure that inaccurate data is
                rectified or
                erased without delay
              </li>
              <li>
                not be kept for longer than is necessary for its given purpose
              </li>
              <li>
                be processed in a manner that ensures appropriate security of Personal Data including protection against
                unauthorised or
                unlawful processing, accidental loss, destruction or damage by using appropriate technical or
                organisation measures
              </li>
              <li>
                comply with the relevant laws and procedures for international transferring of Personal Data applicable
                to us.
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="11. Legal basis for processing your Personal Data" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Certain jurisdictions require that we have a lawful basis to justify our processing of your Personal Data.
          </p>
          <p>
            Where applicable, the lawful basis that upGrad relies upon to justify a particular processing activity may
            differ from
            the lawful basis used to justify a different processing activity.
          </p>
          <p>
            upGrad relies on the following lawful basis to process Personal Data, as permitted under applicable law:
          </p>
          <div>
            <ul>
              <li>
                Processing necessary for the negotiation, execution, or performance of contracts
              </li>
              <li>
                Processing to comply with legal and regulatory obligations
              </li>
              <li>
                Processing in furtherance of our legitimate interests, including our interests to conduct legitimate
                business activities
                (such as improving our products and services, to communicate with you, to secure our systems, among
                other legitimate
                interests)
              </li>
              <li>
                Processing necessary to protect vital interest of a user or any other natural person
              </li>
              <li>
                Processing necessary for public interest
              </li>
              <li>
                Processing based on your consent
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="12. Consent" panelClass="customClass">
        <div class="accordion-content">
          <p>
            We may obtain your consent to collect and use certain types of Personal Data when we are required to do so
            by law.
          </p>
          <p>
            Once consent is obtained from the individual to use his or her information for those purposes, upGrad has
            the
            individual's implied consent to collect or receive any supplementary information that is necessary to fulfil
            the same
            purposes. Express consent will also be obtained if, or when, a new use is identified.
          </p>
          <p>
            Consent may also be implied where a user is given notice and a reasonable opportunity to opt-out of his or
            her personal
            information being used for mail-outs, the marketing of new services or products, and the client, customer,
            member does
            not opt-out.
          </p>
          <p>
            Subject to certain exceptions (e.g., the personal information is necessary to provide the service or
            product, or the
            withdrawal of consent would frustrate the performance of a legal obligation), individuals can withhold or
            withdraw their
            consent for upGrad to use their personal information in certain ways.
          </p>
          <p>
            Further, by using this website/ acknowledging this privacy policy / by voluntarily providing us with your
            Personal Data,
            you consent to collection, storage, and processing of your Personal Data in accordance with this privacy
            policy and our
            Terms of Service.
          </p>
          <p>
            If you refuse or withdraw your consent, or if you choose not to provide us with any required Personal Data,
            we may not
            be able to provide you the services that can be offered on our Platform.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="13. Purpose of collecting Personal Data" panelClass="customClass">
<div class="accordion-content">
          <p>
            We collect your Personal Data for the following purposes
          </p>
          <div>
            <ul>
              <li>
                To fulfil or meet the reason you provided the information;
              </li>
              <li>
                We use your information for managing and processing purposes, including, but not limited to, tracking
                attendance,
                progress and completion of a Program. As part of our management and processing of the Program, we will
                use certain
                Personal Data to administer exams, projects, and other assessments for the Program. For example, as part
                of an exam,
                upGrad may use certain information collected from you in order to verify your identity or to monitor
                your performance
                during the exam to confirm that you are abiding by the applicable testing rules or requirements;
              </li>
              <li>
                To send you updates about the Programs, other upGrad events, platform maintenance or new services
                provided by upGrad,
                among other things, through itself or through third parties, via WhatsApp, email, SMS, phone call or any
                other medium;
              </li>
              <li>
                Provide Chat Room services;
              </li>
              <li>
                To enhance the quality of our content and product offerings;
              </li>
              <li>
                Compliance with security and other mandatory policies and building access;
              </li>
              <li>
                Providing information to relevant external authorities for tax, social security and other purposes as
                legally required;
              </li>
              <li>
                Conducting surveys to assess your satisfaction, including but not limited to its processes or policies;
              </li>
              <li>
                Setting up and maintaining accounts and subscriptions with third parties that provide information and
                research services
                or communication services;
              </li>
              <li>
                Making decisions about your continued engagement, employment or membership;
              </li>
              <li>
                Dealing with legal or regulatory disputes or investigations involving you, our work, or other partners,
                employees,
                workers and contractors, including accidents at work, potential and actual negligence claims and
                professional discipline
                matters;
              </li>
              <li>
                To monitor use of our information and communication systems to ensure compliance with our IT and
                document management
                policies;
              </li>
              <li>
                To ensure network and information security, including preventing unauthorized access to our computer and
                electronic
                communications systems and preventing malicious software distribution;
              </li>
              <li>
                Business management and planning, including accounting, auditing and insuring;
              </li>
              <li>
                Planning or reviewing options in relation to the operation or management;
              </li>
              <li>
                Keeping registers required by law or regulation;
              </li>
              <li>
                Communicating with you, for example to respond to inquiries;
              </li>
              <li>
                Enhancing the safety and security of the services and preventing fraud, or protecting our or our
                customers’, or your
                rights or property;
              </li>
              <li>
                Enforcing applicable terms and conditions and other applicable policies;
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="14. Advertising and Marketing" panelClass="customClass">
        <div class="accordion-content">
          <p>
            We strive to provide you with choices regarding certain Personal Data uses, particularly around marketing
            and
            advertising. You will receive marketing communications from us if you have requested information from us or
            if you
            provided us with your details and expressly consented to receiving that marketing.
          </p>
          <p>
            We may use your Personal Identification, Identity, Contact, Electronic and User generated Data to form a
            view on what we
            think you may want or need, or what may be of interest to you. This is how we decide which services and
            offers may be
            relevant for you.
          </p>
          <p>
            We also enter into agreements with third parties to serve Ads on our behalf across the internet, social
            networking sites
            and blogs. These third parties may collect Personal Data about your visits to our platform and your
            interactions with
            our products and use this information to target advertisements for goods and services.
          </p>
          <p>
            Where electronic direct marketing communications are being sent, you have the option to opt-out in each
            communication
            sent, and this choice will be recognised and adhered to by us.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="15. Disclosure of Personal Data" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad is a global company and may share the personal information collected or provide such access to other
            companies
            within the upGrad group.
          </p>
          <p>
            Examples of third parties with whom upGrad may share Personal Data includes:
          </p>
          <div>
            <ul>
              <li>
                With government bodies, including tax and social security authorities, to comply with applicable laws
                (including
                employment and tax laws), to obtain licenses or approvals, and upon request during an audit or
                assessment;
              </li>
              <li>
                With suppliers, subcontractors and service providers, to maintain an efficient and commercially viable
                business,
                including technology, telecom, internet providers;
              </li>
              <li>
                With professional advisers, consultants, and employment and recruitment agencies, to conduct background
                verification and
                reference checks, administer benefits and payroll, deal with disciplinary and grievance issues and
                maintain emergency
                contact details;
              </li>
              <li>
                With our legal advisors and external auditors for legal advice and to conduct business audits;
              </li>
              <li>
                With service providers for business continuity management and contingency planning in the event of
                business disruptions.
              </li>
              <li>
                With certain companies in order to establish a membership to participate in digital wallets, payment
                services or rewards
                programme
              </li>
              <p>
                We require all third parties to respect the security of your Personal Data and to treat it in accordance
                with the law.
                We do not allow our third-party service providers to use your Personal Data for their own purposes and
                only permit them
                to process your Personal Data for specified purposes and in accordance with our instructions.
              </p>
            </ul>
          </div>
          <p>
            In addition to the examples cited above, upGrad also shares your Personal Data with:
          </p>
          <table class="content-table-class">
            <thead>
              <tr>
                <th>
                  Recipients
                </th>
                <th>
                  Category(ies) of Personal Data we share
                </th>
                <th>
                  Why we share it
                </th>
                <th>
                  Location(s)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <h6>Educational Partners</h6>
                  <div>
                    <ul>
                      <li>
                        University or company offering the course
                      </li>
                      <li>
                        External graders
                      </li>
                      <li>
                        Mentors
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Personal Identification Data
                      </li>
                      <li>
                        Personal Characteristics Data
                      </li>
                      <li>
                        Contact Data
                      </li>
                      <li>
                        User generated data
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Evaluate and assess your progress and performance in the Program
                      </li>
                      <li>
                        report on your progress in the Program
                      </li>
                      <li>
                        enable them to issue a certificate to you on completion of the Program
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  <h6>
                    Global
                  </h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>
                    Employers; Sponsors and Scholarship Providers
                  </h6>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Personal Identification Data
                      </li>
                      <li>
                        Personal Characteristics Data
                      </li>
                      <li>
                        Contact Data
                      </li>
                      <li>
                        User generated data
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  If you are taking a Program that is sponsored or paid for by your employer or a sponsor, or if you have availed a
                  scholarship from a third-party scholarship provider, we may share your Personal Data and grades, evaluations or progress
                  in the Program with your employer/sponsor/scholarship provider. This information may be shared at any time during the
                  Program or afterwards.
                </td>
                <td>
                  <h6>
                    Global
                  </h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>
                    Service Providers
                  </h6>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Personal Identification Data
                      </li>
                      <li>
                        Personal Characteristics Data
                      </li>
                      <li>
                        Contact Data
                      </li>
                      <li>
                        User generated data
                      </li>
                      <li>
                        Financial Data
                      </li>
                      <li>
                        Electronic Identification Data
                      </li>
                      <li>
                        Data generated from inquires
                      </li>
                      <li>
                        Marketing Data
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  We provide access to or share your information with operations and maintenance contractors and other third parties who
                  perform services on our behalf strictly on confidential terms. They provide a variety of services to us, including
                  billing, sales, marketing, test proctoring, couriers, mentoring, recruitment consulting, product content and features,
                  advertising, analytics, research, customer service, data storage, security, fraud prevention, credit facilities, payment
                  processing and legal services
                </td>
                <td>
                  <h6>
                    Global
                  </h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>
                    Third Parties
                  </h6>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Personal Identification Data
                      </li>
                      <li>
                        Personal Characteristics Data
                      </li>
                      <li>
                        Contact Data
                      </li>
                      <li>
                        User generated data
                      </li>
                      <li>
                        Financial Data
                      </li>
                      <li>
                        Electronic Identification Data
                      </li>
                      <li>
                        Data generated from inquires
                      </li>
                      <li>
                        Marketing Data
                      </li>
                      <li>
                        Education and Recruitment Data
                      </li>
                      <li>
                        Behavioural Data
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        we share certain Personal Data and materials with third parties including, but not limited to, service providers such as
                        Facebook or WhatsApp in order to provide you services that you have requested or services that upGrad provides in
                        conjunction with the Programs
                      </li>
                      <li>
                        to arrange and provide networking activities to previous, current or potential students of upGrad
                      </li>
                      <li>
                        may share information that can be used to directly contact you with third-party business partners, such as companies
                        that may be offering products or services or other opportunities that may be of interest to you.
                      </li>
                      <li>
                        To third party business partners
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  <h6>
                    Global
                  </h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>
                    Recruitment Service providers
                  </h6>
                  <div>
                    <ul>
                      <li>
                        Recruitment agency
                      </li>
                      <li>Potential employers</li>
                    </ul>
                  </div>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Personal Identification Data
                      </li>
                      <li>
                        Personal Characteristics Data
                      </li>
                      <li>
                        Contact Data
                      </li>
                      <li>
                        User generated data
                      </li>
                      <li>
                        Education and Recruitment Data
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  If you opt for any of our recruitment services or if you participate in any of our recruitment activities, we will be
                  sharing your information with recruiters and potential employers.
                </td>
                <td>
                  <h6>
                    Global
                  </h6>
                </td>
              </tr>
              <tr>
                <td>
                  <h6>
                    Associate and Business Transfers
                  </h6>
                </td>
                <td>
                  <div>
                    <ul>
                      <li>
                        Personal Identification Data
                      </li>
                      <li>
                        Personal Characteristics Data
                      </li>
                      <li>
                        Contact Data
                      </li>
                      <li>
                        User generated data
                      </li>
                    </ul>
                  </div>
                </td>
                <td>
                  We share your Personal Data with our associates for business purposes.<br/>
                  upGrad may disclose and/or transfer your Personal Data to an acquirer, assignee or other successor entity in connection
                  with a sale, merger, or reorganisation of all or substantially all of the equity, business or assets of upGrad to which
                  your Personal Data relates
                </td>
                <td>
                  <h6>
                    Global
                  </h6>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </accordion-group>
      <accordion-group heading="16. Data subject rights" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Some jurisdictions have provided individuals with certain rights in relation to the processing of their
            Personal Data.
            This is the case where you or the any of our subsidiaries or affiliates with which you interact is located
            in the
            European Union, though these rights may be available in other jurisdictions as well. These rights are not
            available to
            everyone, and they do not necessarily apply in all contexts. Depending on applicable law, you may have the
            right to:
          </p>
          <div>
            <ul>
              <li>
                Request access to your Personal Data.
              </li>
              <li>
                Request correction of your Personal Data (should your Personal Data be inaccurate, incomplete, or
                obsolete).
              </li>
              <li>
                Request deletion of your Personal Data
              </li>
              <li>
                Withdraw your consent to processing (where we processed Personal Data on the basis of your consent).
                Please note that
                withdrawing your consent applies only to future processing activities.
              </li>
              <li>
                Object to the processing of your Personal Data.
              </li>
              <li>
                Request restrictions on the processing of your Personal Data.
              </li>
              <li>
                Request the transfer of your Personal Data to you or a third party.
              </li>
              <li>
                Opt-out of certain transfers to third parties.
              </li>
              <li>
                Request to opt out of automated decision making.
              </li>
              <p>
                To exercise a right that you believe you may be entitled to under applicable law, please write to us at
                <a href="mailto:dpo@upgrad.com">
                  dpo@upgrad.com
                </a>.
              </p>
              <p>
                We may need to verify your identity before we fulfil your request.
              </p>
              <p>
                Please note that certain conditions in relation to processing of your rights, will vary as many
                countries have varying
                data privacy rights. Our response and further processing of request to exercise these rights will depend
                upon the law
                applicable in relation to the rights exercised by you. We may refuse requests that are unreasonably
                repetitive, require
                disproportionate technical effort, risk the privacy of others, may compromise and ongoing investigation,
                or are
                impractical. It is our policy to never discriminate against you for exercising any of these rights.
              </p>
              <p>
                You may have the right to complain to a data protection authority about our processing of your Personal
                Data. For more
                information, please contact your local data protection authority.
              </p>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="17. Our Policy on Children’s Data" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Children’s data privacy is important to us. Our Sites are not intended for children Age to constitute a user
            as children
            is different for different jurisdictions. The age (for valid consent) of children varies across
            jurisdictions. For
            example, under GDPR child is a person aged 16 years or below, and in United Kingdom, children is someone who
            is aged 13
            , in case of Singapore and Qatar the valid age for providing consent is 18 years.
          </p>
          <p>
            As a general policy, our company does not engage in the collection, processing, storage, use, dissemination,
            and
            transfer of Personal Data of children.
          </p>
          <p>
            In case such a collection becomes necessary for the performance of our contractual obligations, or when
            required under
            the concerned law, we shall notify you in a time-bound and appropriate manner, informing the purposes and
            reasons for
            such collection and seek your explicit consent, and where applicable, parental authorization, prior to the
            processing of
            such data.
          </p>
          <p>
            We will take appropriate steps to delete any Personal Data of children’s that has been collected on our
            website without
            verified parental consent upon learning of the existence of such Personal Data, subject to conditions
            stipulated in the
            laws of applicable jurisdiction.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="18. Data Security" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad will ensure that appropriate technical and organizational measures are in place, supported by privacy
            impact and
            risk assessments, to ensure a high level of security for Personal Data, and secure environment for
            information held both
            manually and electronically.
          </p>
          <p>
            upGrad implements appropriate security measures designed to prevent unlawful or unauthorized processing of
            personal
            information and accidental loss of or damage to personal information. upGrad maintains written security
            management
            policies and procedures designed to prevent, detect, contain, and correct violations of measures taken to
            protect the
            confidentiality, integrity, availability, or security of your Personal Information. These policies and
            procedures assign
            specific data security responsibilities and accountabilities to specific individuals, include a risk
            management program
            that includes periodic risk assessment and provide an adequate framework of controls that safeguard your
            personal
            information.
          </p>
          <p>
            In addition, as part of its organizational security measures, employees at upGrad must:
          </p>
          <div>
            <ul>
              <li>
                ensure that all files or written information of a confidential nature are stored in a secure manner and
                are only
                accessed by people who have a need and a right to access them
              </li>
              <li>
                ensure that all files or written information of a confidential nature are not left where they can be
                read by
                unauthorised people
              </li>
              <li>
                check regularly on the accuracy of data being entered into computers
              </li>
              <li>
                always use the passwords provided to access the computer system cautiously and such access should not be
                circulated,
                unless absolutely necessary
              </li>
              <li>
                use computer screen blanking to ensure that Personal Data is not left on screen when not in use.
              </li>
            </ul>
          </div>
          <p>
            Personal Data should not be kept or transported on laptops, USB sticks, or similar devices, unless
            authorised by [insert
            details]. Where Personal Data is recorded on any such device it should be protected by:
          </p>
          <div>
            <ul>
              <li>
                ensuring that data is recorded on such devices only where absolutely necessary
              </li>
              <li>
                using an encrypted system — a folder should be created to store the files that need extra protection and
                all files
                created or moved to this folder should be automatically encrypte
              </li>
              <li>
                ensuring that laptops or USB drives are not left lying around where they can be stolen.
              </li>
            </ul>
          </div>
          <p>
            Failure to follow the Company’s rules on data security may be dealt with via the Company’s disciplinary
            procedure.
            Appropriate sanctions include dismissal with or without notice dependent on the severity of the failure.
          </p>
          <p>
            We also take steps to ensure that our service providers, contractors and other third parties maintain
            similar level of
            data protection measures when processing your Personal Data. While we strive to secure your Personal Data,
            please note
            that 100% security of Personal Data cannot be guaranteed and that upGrad shall not be liable for any misuse
            or loss of
            Personal Data carried out by third party cloud service provider.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="19. International data transfers" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Our website is primarily operated and managed on servers located and operated within India. However, owing
            to the global
            nature of upGrad, your Personal Data may also be stored in third party data servers located in other
            countries where
            upGrad provides its products and services.
          </p>
          <p>
            upGrad engages sub-contractors, service providers and other third parties for facilitating our products,
            service
            offerings and to offer support services to you, and your Personal Data may be transferred to servers of such
            sub-contractors, service providers and other third parties. Depending upon the location of our service
            providers, your
            information, including Personal Data, may be transferred to and maintained on computers located outside of
            your state,
            province, country or other governmental jurisdiction where the data protection laws may differ than those
            from your
            jurisdiction.
          </p>
          <p>
            Further, your Personal Data may be transferred may be shared, disclosed, and transferred between various
            upGrad group
            companies where such transfers are required for legitimate business reasons.
          </p>
          <p>
            Where required under applicable law we will seek your express consent for such transfers. In all other
            cases, by
            consenting to this policy, you also provide consent to upGrad to transfer your Personal Data to upGrad
            affiliated
            companies, service providers or any third-party entity in locations around the world. We take steps to
            ensure that a
            degree of data protection which is similar to this policy is afforded to such Personal Data transferred.
          </p>
          <p>
            Where upGrad transfers your personal information internationally, we will comply with applicable legal
            requirements and
            where required we will enter into a data transfer agreement with the recipient of the personal information,
            which in the
            case of European Personal Data may include the Standard Contractual Clauses. In other cases, and where
            applicable, we
            shall enter into separate Data Processing Agreements with the third parties / service providers /
            contractors and such
            other recipients of Personal Data. Further as the Company takes steps to ensure that transfers of Personal
            Data to any
            public authority cannot be massive, disproportionate, and indiscriminate in a manner that would go beyond
            what is
            necessary in a democratic society. In the event of conflicts between these and public authority
            requirements, the
            company will find a practical solution that fulfils the purpose of this Policy.
          </p>
          <p>
            We are committed to take all steps reasonably necessary to ensure that your data is treated securely and in
            accordance
            with our data privacy and security standards.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="20. Records management" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Records management refers to a set of activities required for systematically controlling the creation,
            distribution,
            use, maintenance, and disposition of recorded information maintained as evidence of business activities and
            transactions. It is impossible to be compliant with information law without robust records management
            policies and
            practises. Good records management practices ensure not only record quality, but that Personal Data is only
            kept for as
            long as necessary for its original purpose and help support data minimization.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="21. Organization and Responsibilities" panelClass="customClass">
        <div class="accordion-content">
          <p>
            upGrad will maintain records of data processing as required by the laws.
          </p>
          <p>
            The ‘Data Protection Officer’ (DPO) has the specific responsibility of overseeing data protection and
            ensuring that we
            comply with the data protection principles and relevant legislation. The DPO will ensure that the Data
            Processing
            Register is kept up to date and demonstrates how the data protection principles are adhered to by our
            activities.
            Individual members of staff have a duty to contribute to ensure that the measures outlined in the Register
            are
            accurately reflected in our practice.
          </p>
          <p>
            Our compliance with relevant policies and regulatory requirements in respect of data protection as part of
            our Data
            Management Strategy will be periodically monitored internally by a designated governance group. All
            employees,
            volunteers, consultants, partners, or other parties who will be handling Personal Data on behalf of upGrad
            will be
            appropriately trained and supervised where necessary.
          </p>
          <p>
            The collection, storage, use and sharing of Personal Data will be regularly reviewed by the Data Protection
            Officer, the
            Governance Group, and any relevant business area. We will adhere to relevant codes of conduct where they
            have been
            identified and discussed as appropriate.
          </p>
          <p>
            Where there is likely to be a high risk to individuals rights and freedoms due to a processing activity, we
            will first
            undertake a Data Protection Impact Assessment (DPIA) and consult with the relevant supervisory authority
            prior to
            processing, if necessary.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="22. Conflicts of Law" panelClass="customClass">
        <div class="accordion-content">
          <p>
            This Policy is intended to comply with the laws and regulations in the place of establishment and of the
            countries in
            which company operates. In the event of any conflict between this Policy and applicable laws and
            regulations, the latter
            shall prevail.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="23. Retention of Personal Data" panelClass="customClass">
        <div class="accordion-content">
          <p>
            We retain your Personal Data, not longer than necessary for the purposes for which it was collected. The
            length of time
            to retain Personal Data depends on the purposes for which we collect and use it and/or as may be required to
            comply with
            applicable laws, to establish, exercise, or defend our legal rights.
          </p>
          <p>
            The users can exercise their rights enumerated herein. Also, if in case required to extend the period of
            retention of
            such data, we shall obtain your consent for the same. Further, we may also dispose the data prior to
            completion of the
            period of retention, if the purpose for which it was collected is exhausted.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="24. Procedures" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The Company has taken the following steps to protect the Personal Data of relevant stakeholders, which it
            holds or to
            which it has access:
          </p>
          <div>
            <ul>
              <li>
                it appoints or employs employees with specific responsibilities for: o the processing and controlling of
                data <br />
                - the comprehensive reviewing and auditing of its data protection systems and procedures<br />
                - overviewing the effectiveness and integrity of all the data that must be protected.<br />
                - There are clear lines of responsibility and accountability for these different roles.
              </li>
              <li>
                it provides its employees with information and training to make them aware of the importance of
                protecting Personal
                Data, to teach them how to do this, and to understand how to treat information confidentially
              </li>
              <li>
                it can account for all Personal Data it holds, where it comes from, who it is shared with and also who
                it might be
                shared with
              </li>
              <li>
                it carries out risk assessments as part of its reviewing activities to identify any vulnerabilities in
                its Personal Data
                handling and processing, and to take measures to reduce the risks of mishandling and potential breaches
                of data
                security. The procedure includes an assessment of the impact of both use and potential misuse of
                Personal Data in and by
                the Company
              </li>
              <li>
                it recognises the importance of seeking individuals’ consent for obtaining, recording, using, sharing,
                storing and
                retaining their Personal Data, and regularly reviews its procedures for doing so, including the audit
                trails that are
                needed and are followed for all consent decisions. The Company understands that consent must be freely
                given, specific,
                informed and unambiguous. The Company will seek consent on a specific and individual basis where
                appropriate. Full
                information will be given regarding the activities about which consent is sought. Relevant individuals
                have the absolute
                and unimpeded right to withdraw that consent at any time
              </li>
              <li>
                it has the appropriate mechanisms for detecting, reporting and investigating suspected or actual
                Personal Data breaches,
                including security breaches. It is aware of its duty to report significant breaches that cause
                significant harm to the
                affected individuals to the relevant supervisory authority, and is aware of the possible consequences
              </li>
              <li>
                it is aware of the implications international transfer of Personal Data internationally.
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
      <accordion-group heading="25. Breach notification" panelClass="customClass">
        <div class="accordion-content">
          <p>
            Where a data breach is likely to result in a risk to the rights and freedoms of individuals, it will be
            reported to the
            relevant supervisory authority within 72 hours of the Company becoming aware of it and may be reported in
            more than one
            instalment. Individuals will be informed directly in the event that the breach is likely to result in a high
            risk to the
            rights and freedoms of that individual. If the breach is sufficient to warrant notification to the public,
            the Company
            will do so without undue delay.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="26. External Links on our website" panelClass="customClass">
        <div class="accordion-content">
          <p>
            For your convenience we may provide links to sites operated by organizations other than upGrad ("Third Party
            Sites")
            that we believe may be of interest to you. We do not disclose your Personal Data to these Third-Party Sites
            unless we
            have a lawful basis on which to do so. We do not endorse and are not responsible for the privacy practices
            of these
            Third-Party Sites. If you choose to click on a link to one of these Third-Party Sites, you should review the
            privacy
            policy posted on the other websites to understand how that Third-Party website collects and uses your
            Personal Data.
          </p>
          <p>
            upGrad uses YouTube API Services to play YouTube videos. When a YouTube video is played, the app
            communicates directly
            with the content provider (YouTube) and not with upGrad. Users of the app should be aware of the Google
            Privacy Policy
            available at
            <a href="https://policies.google.com/privacy" target="_blank">
              https://policies.google.com/privacy
            </a>
            , which states how YouTube treats user data. upGrad does not have any
            record of the videos watched or any other user related YouTube API data.
          </p>
          <p>
            We take no responsibility for the content or practices of any third-party services in the Third Party Sites.
          </p>
          <p>
            We encourage you to carefully review the terms of services/use of any third-party services or Third Party
            Sites you
            access.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="27. Information for California Residents" panelClass="customClass">
        <div class="accordion-content">
          <p>
            In particular, depending upon your relationship with upGrad we may have collected the following categories
            of Personal
            Data within the last twelve (12) months:
          </p>
          <table class="content-table-class">
            <thead>
              <tr>
                <th>
                  Category
                </th>
                <th>
                  Examples
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Identifiers.
                </td>
                <td>
                    A real name, alias, postal address, unique personal identifier, online identifier, Internet Protocol address, email
                    address, account name, Social Security number, driver’s license number, passport number, or other similar identifiers.
                </td>
              </tr>
              <tr>
                <td>
                  Personal Information categories listed in the California Customer Records statute (Cal. Civ. Code § 1798.80(e)).
                </td>
                <td>
                  A name, signature, Social Security number, physical characteristics or description, address, telephone number, passport
                  number, driver’s license or state identification card number, insurance policy number, education, employment, employment
                  history, bank account number, credit card number, debit card number, or any other financial information, medical
                  information, or health insurance information. Some Personal Information included in this category may overlap with other
                  categories.
                </td>
              </tr>
              <tr>
                <td>
                  Protected classification characteristics under California or federal law.
                </td>
                <td>
                  Age, race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical
                  or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth and related
                  medical conditions), sexual orientation, veteran or military status, genetic information (including familial genetic
                  information).
                </td>
              </tr>
              <tr>
                <td>
                  Commercial information.
                </td>
                <td>
                  Records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming
                  histories or tendencies.
                </td>
              </tr>
              <tr>
                <td>
                  Biometric information.
                </td>
                <td>
                  Genetic, physiological, behavioural, and biological characteristics, or activity patterns used to extract a template or
                  other identifier or identifying information, such as, fingerprints, faceprints, and voiceprints, iris or retina scans,
                  keystroke, gait, or other physical patterns, and sleep, health, or exercise data.
                </td>
              </tr>
              <tr>
                <td>
                  Internet or other similar network activity.
                </td>
                <td>
                  Browsing history, search history, information on a consumer’s interaction with a website, application, or advertisement.
                </td>
              </tr>
              <tr>
                <td>
                  Geolocation data.
                </td>
                <td>
                  Physical location or movements.
                </td>
              </tr>
              <tr>
                <td>
                  Sensory data.
                </td>
                <td>
                  Audio, electronic, visual, thermal, olfactory, or similar information
                </td>
              </tr>
              <tr>
                <td>
                  Professional or employment-related information.
                </td>
                <td>
                  Current or past job history or performance evaluations.
                </td>
              </tr>
              <tr>
                <td>
                  Non-public education information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R.
                  Part 99)).
                </td>
                <td>
                  Education records directly related to a student maintained by an educational institution or party acting on its behalf,
                  such as grades, transcripts, class lists, student schedules, student identification codes, student financial
                  information, or student disciplinary records.
                </td>
              </tr>
              <tr>
                <td>
                  Inferences drawn from other Personal Information.
                </td>
                <td>
                    Profile reflecting a person’s preferences, characteristics, psychological trends, predispositions, behaviour, attitudes,
                    intelligence, abilities, and aptitudes.
                </td>
              </tr>
              <tr>
                <td>
                  Sensitive personal Information
                </td>
                <td>
                  Consumers Social Security, driver's license, identification card, passport number, a consumer’s account log‐in,
                  financial account, debit card, or credit card number in combination with any required security or access code, password,
                  or credentials allowing access to an account, genetic data, contents of consumer's mail, email or text messages,
                  consumers racial or ethnic origin, religious or philosophical beliefs, or union membership and their genetic data
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            For more information on types of Personal Data we collect, including the sources we receive information
            from, review
            section Types of Personal Data collected. We collect and use these categories of personal information for
            the business
            purposes described in section Purpose of Collecting data, including to provide and manage our platforms.
          </p>
          <p>
            upGrad does not engage in selling of Personal Data (as defined under CCPA). In case of advertising
            technology activities
            used, such as those disclosed in the Advertising and Marketing & Data Analytics section, we will comply with
            applicable
            law as to such activity. If you are a California consumer and wish to opt-out of the sale of your Personal
            Data, See the
            “Do Not Sell My Personal Information” page on our Site homepage to exercise your right and know more on how
            to opt-out
            of the sale of Personal Information.
          </p>
          <p>
            You may also submit a request to us at
            <a href="mailto:dpo@upgrad.com">
              dpo@upgrad.com
            </a>.
          </p>
          <p>
            We use and partner with different types of entities to assist with our daily operations and manage our
            platforms. Please
            review the section
            <strong>
              Disclosure of your Personal Data
            </strong>
            for more detail about the parties we have shared your Personal Data
            with.
          </p>
          <p>
            We will not discriminate against you for exercising any of your CCPA rights. We may choose in the future to
            offer you
            certain financial incentives permitted by the CCPA that can result in different prices, rates, or quality
            levels. Any
            CCPA-permitted financial incentive we offer will reasonably relate to your Personal Data’s value and contain
            written
            terms that describe the Program’s material aspects.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="28. Use of this website and our Terms of Service" panelClass="customClass">
        <div class="accordion-content">
          <p>
            This website is the property of the upGrad. Our Terms of Use and this Privacy Policy collectively govern the
            use of the
            Platform and the Programs offered by upGrad. This Privacy Policy shall form a part of the Terms by way of
            reference. By
            using this website and the information offered herein, you indicate your acceptance of these Terms of Use.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="29. Updates to this policy" panelClass="customClass">
        <div class="accordion-content">
          <p>
            We may update our Privacy Policy from time to time. We will take reasonable steps to inform all upGrad
            entities,
            Customers, Business Partners, and other data subjects affected by the revisions by posting the new Privacy
            Policy on
            this page and/or via email.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="30. Data Controller/ Company Details" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The "Data Controller" (i.e., upGrad) means the entity that will make the decisions about how your data is
            used and that
            is responsible for deciding how it holds personal information about you.
          </p>
          <p>
            Since upGrad is made up of different legal entities, the entity that will be the controller for your data is
            dependent
            on the situation where your Personal Data is collected.
          </p>
        </div>
      </accordion-group>
      <accordion-group heading="31. Data Protection Officer" panelClass="customClass">
        <div class="accordion-content">
          <p>
            The company, in accordance with the applicable laws, and all applicable rules made thereunder, has appointed
            a Data
            Protection Officer; who can be reached at the details below:
          </p>
          <p>
            Name: Mr. Raj Dogra <br />
            Email Address:
            <a href="mailto:dpo@upgrad.com">
              dpo@upgrad.com
            </a>
          </p>
        </div>
      </accordion-group>
      <h2 style="text-align: left;margin-top: 20px;">
        Important Disclaimer
      </h2>
      <accordion-group heading="1. Key Points" panelClass="customClass">
        <div class="accordion-content">
          <div>
            <ul>
              <li>
                upGrad is solely a Learning Partner providing upskilling training. We are not a recruitment agency/partner and do not
                offer job guarantees, interview guarantees, or any similar commitments, warranties, or assurances.
              </li>
              <li>
                upGrad is not responsible for participant outcomes, nor for any false/incorrect promises made by third parties. Any
                outcome post-completion depends entirely on their individual effort and aptitude. Merely completing the program does not
                guarantee any specific outcome.
              </li>
              <li>
                upGrad will access, store, and use participant data to communicate program-related updates. By registration and/or
                enrolling, participants consent to receive communications from upGrad.
              </li>
              <li>
                This is not a degree or diploma program and does not constitute formal academic certification.
              </li>
            </ul>
          </div>
        </div>
      </accordion-group>
    </accordion> -->
    <p class="pb-0">To register for our programs, we require certain personal information. By proceeding, you acknowledge and consent to the collection, processing, and storage of your data in accordance with our <a href="https://www.upgrad-enterprise.com/privacy-policy" target="_blank">Privacy Policy</a> and <a href="https://www.upgrad-enterprise.com/terms-conditions" target="_blank">Terms of Use</a>.
    </p>
    <p><em>Note</em>: You can withdraw your consent at any time by contacting <a href="mailto:dpo@upgrad.com">dpo@upgrad.com</a></p>
    <div class="d-flex checkbox-content">
      <input type="checkbox" [(ngModel)]="isChecked" style="margin-right: 8px;" > I have read and agree to the Privacy Policy and Terms of Use.
    </div>
    <div class="modal-footer">

      <button type="submit" class="btn red--button light-color" (click)="submitAcceptance()" [disabled]="!isChecked" [ngClass]="!isChecked?'disable-class':''">Accept</button>
    </div>
  </div>
</div>

